import React from "react";
import SearchBar from "../SearchBar/SearchBar";
import BannerImg from "../../assets/banner.jpeg";

const HeroSection = ({ searchResult, setSearchResult, handleFilter }) => {
  // // State to manage input values
  // const [city, setCity] = useState('');
  // const [price, setPrice] = useState('');
  // const [complete, setComplete] = useState('');
  // const [propertyType, setPropertyType] = useState('');

  // // Function to handle search button click

  // const handleSearch = () => {
  //   const result = {
  //     city: city || 'Dubai',
  //     complete: complete || 'Any',
  //     price: price || 'Any',
  //     propertyType: propertyType || 'Any',
  //   };
  //   setSearchResult(result);
  //   handleFilter(result);
  // };

  // const [toggle, setToggle] = useState(false);
  // const handleClick = () => setToggle(!toggle);
  // const handleSelect = (value) => {
  //   setCity(value);
  //   setToggle(false);
  // };

  const options = [
    "",
    "Al Barari",
    "Al Barsha",
    "Al Furjan",
    "Al Habtoor City",
    "Al Hamra Village",
    "Al Jaddaff",
    "Al Jurf",
    "Al Kifaf",
    "Al Marjan Island",
    "Al Reem Island",
    "Al Safa",
    "Al Sufouh",
    "Al Wasl",
    "Al Zorah",
    "Arabian Ranches",
    "Arabian Ranches 2",
    "Arabian Ranches 3",
    "Arjan",
    "Bluewaters Island",
    "Burj Khalifa District",
    "Business Bay",
    "City Walk",
    "Culture Village",
    "DIFC",
    "Deira",
    "Downtown Dubai",
    "Downtown Jebel Ali",
    "Dubai Canal",
    "Dubai Creek Harbour",
    "Dubai Festival City",
    "Dubai Healthcare City",
    "Dubai Hills Estate",
    "Dubai Investment Park",
    "Dubai Islands",
    "Dubai Marina",
    "Dubai Production City",
    "Silicon Oasis",
    "Dubai South",
    "Dubai Sports City",
    "Dubailand",
    "Emaar Beachfront",
    "Emaar South",
    "Emirates Hills",
    "Emirates Living",
    "Expo City Dubai",
    "Falconcity",
    "Hudayriyat Island",
    "International City",
    "JBR",
    "Jebel Ali",
    "Jebel Ali Village",
    "Jumeira Bay",
    "Jumeirah",
    "Jumeirah Golf Estate",
    "Jumeirah Height",
    "Jumeirah Islands",
    "Jumeirah Lake Towers",
    "Jumeirah Park",
    "Jumeirah Village Circle",
    "Jumeirah Village Triangle",
    "MBR City",
    "Madinat Badr",
    "Madinat Jumeirah Living",
    "Majan",
    "Marine Drive",
    "Meadows",
    "Meydan City",
    "Mirdif Hills",
    "Motor City",
    "Mudon",
    "Muscat Bay",
    "Nad Al Hammar",
    "Nad Al Sheba",
    "Palm Jebel Ali",
    "Palm Jumeirah",
    "Pearl Jumeirah",
    "Port De La Mer",
    "Remraam",
    "Sheikh Zayed Road",
    "Sobha Hartland",
    "Springs",
    "Studio City",
    "The Lakes",
    "The Opera District",
    "The Valley",
    "The Views",
    "Tilal Al Ghaf",
    "Town Square",
    "Umm Suqeim",
    "Villanova",
    "Yas Bay",
    "Zaabeel",
  ];

  return (
    <section
      className="relative h-[50vh] md:h-[80vh] *:font-sans flex flex-col justify-center items-center"
      style={{
        overflow: "hidden",
      }}
    >
      <div className="absolute inset-0">
        <img
          src={BannerImg}
          className="object-cover w-full h-full"
          alt="Dubai Cityscape"
        />
        <div className="absolute inset-0 bg-black opacity-20"></div>
      </div>

      {/* Content of the section */}
      <div className="absolute flex items-center justify-center w-full ">
        <SearchBar
          handleFilter={handleFilter}
          searchResult={searchResult}
          setSearchResult={setSearchResult}
          options={options}
        />
      </div>
    </section>
  );
};

export default HeroSection;
